export function isListingPricingComplete(listing) {
  const mode = listing?.pricingMode ?? "";
  const price = Number(listing?.price) || 0;
  return (mode === "oneTime" || mode === "subscription") && price > 0;
}

/** Live on the website once pricing is saved (status may lag if saved before gateway publish). */
export function isListingPublished(listing) {
  return listing?.status === "published" || isListingPricingComplete(listing);
}

/** Appwrite stores listing price as a string attribute. */
export function formatListingPriceForAppwrite(amount) {
  return Number(amount).toFixed(2);
}

export function priceLabelForListing(listing) {
  if (!isListingPricingComplete(listing)) return "Pricing not set";
  const price = Number(listing.price) || 0;
  const amount = `$${price.toFixed(2)}`;
  return listing.pricingMode === "subscription" ? `${amount}/mo` : amount;
}
